import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ rejectPayment, setRejectPayment ] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        rejectPayment, setRejectPayment
    })
}